import { render, staticRenderFns } from "./BtnDownloadProcesso.vue?vue&type=template&id=64a0f7b2&"
import script from "./BtnDownloadProcesso.vue?vue&type=script&lang=js&"
export * from "./BtnDownloadProcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports